
















































































































































































import IRPTParameters from '@/store/models/IRPTParameters';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TableRowAction from '../shared/TableRowAction.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class RPTParametersSelector extends Vue {
    searchRPTParameters: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Name', value: 'parameterName' },
        { text: 'Description', value: 'parameterDescription' },
        { text: 'Type', value: 'parameterType' },
        { text: 'DataSource', value: 'dataSource' },
        { text: 'ValueMember', value: 'valueMember' },
        { text: 'DisplayMember', value: 'displayMember' },
        { text: 'Actions', value: '' }
    ];
    editedIndex : number = -1;
    editedItem : IRPTParameters = {
        id: "",
        parameterName: "",
        parameterDescription: "",
        parameterType: "",
        dataSource: "",
        valueMember: "",
        displayMember: ""
    }
    defaultItem : IRPTParameters = {
        id: "",
        parameterName: "",
        parameterDescription: "",
        parameterType: "",
        dataSource: "",
        valueMember: "",
        displayMember: ""
    }
    sortBy: string = 'parameterName';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    RPTParametersList !: IRPTParameters[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedRPTParameters : IRPTParameters[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Parameter' : 'Edit Parameter'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetRPTParameters() {
        this.selectedRPTParameters = [];
    }

    editRPTParameters (item: any, dbox = true) {
        this.editedIndex = this.RPTParametersList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveRPTParameters (listAdressType: IRPTParameters) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedRPTParameters[0]) {
                this.close();
                this.$emit('editRPTParameters', this.editedItem);
                Object.assign(this.RPTParametersList[this.editedIndex], this.editedItem);
            } else {
                this.selectedRPTParameters[0] = this.editedItem;
                this.$emit('saveRPTParameters', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteRPTParameters (listAdressType: IRPTParameters) {
        this.$emit('deleteRPTParameters', listAdressType);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectRPTParameters(item : any) : void {
        if (!this.selectedRPTParameters.includes(item)) {
            this.selectedRPTParameters = [];
            this.selectedRPTParameters = [item];
        } else {
            this.selectedRPTParameters = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
